import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { connect } from '../../hoc';
import '../../theme/styles/subtitles.css';
import { subtitlePositionAndSize } from '../../utils/tools';
import { SUBTITLE_CONTAINER_STYLE, SUBTITLE_LINE_STYLE } from './styles';

function SubtitleContainer({
  width,
  height,
  tags,
  active,
  alignment,
  position,
  style = {},
  sideMargin = 0,
  fontFamily, fontRatio = 1
}) {
  const tagStyles = useMemo(
    () => ({
      ...SUBTITLE_LINE_STYLE,
      fontFamily,
      fontSize: `${1 * fontRatio}em`
    }),
    [fontRatio, fontFamily]
  );

  return active ? (
    <div style={style}>
      <div
        className="ftv-magneto--subtitles"
        style={{
          ...SUBTITLE_CONTAINER_STYLE,
          ...subtitlePositionAndSize({ width, height, alignment, position, fontRatio }, sideMargin)
        }}
      >
        {tags.map(({ tagName, text, cssClasses }) => {
          const Tag = tagName;
          return <Tag className={cssClasses?.join(' ') || ''} style={tagStyles}>{text}</Tag>;
        })}
      </div>
    </div>
  ) : null;
}

export default connect(({
  subtitles: { settings: { fontFamily, fontRatio } }
}) => ({
  fontFamily, fontRatio
}))(SubtitleContainer);
